<template>
  <div class="AContainer">
    <AFilter :isReserve="isReserve" @changeQuery="currentQuery" @openReserve="setVisible" />
    <a-table
      :columns="AppointColumns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="id"
      :scroll="{ x: '100%', y: 'calc(100vh - 330px)' }"
    >
      <template #reserveDate="{ text: reserveDate }">
        <span>
          {{ handleTimeShowWeek(reserveDate) || '--' }}
        </span>
      </template>
      <template #revisitType="{ text: revisitType }">
        <span>
          {{ ['线上问诊', '门诊就诊'][revisitType - 1] || '无' }}
        </span>
      </template>
      <template #reserveState="{ text: reserveState }">
        <span>
          {{ Config.RESERCE_STATE_MAP[Number(reserveState)] || '无' }}
        </span>
      </template>
      <template #followupTrackAiCallFlag="{ record }">
        <a v-if="record.followupTrackAiCallFlag" @click="summaryDetail(record, 0)">查看小结</a>
        <span v-else>——</span>
      </template>
      <template #operation="{ record }">
        <a @click="rowDetail(record)">查看详情</a>
      </template>
    </a-table>
    <a-row type="flex" justify="end" style="margin-top: 20px">
      <a-col>
        <a-pagination
          v-if="Total"
          show-size-changer
          show-quick-jumper
          v-model:current="current"
          v-model:pageSize="pageSize"
          :total="Total"
          @change="listquery"
          @showSizeChange="listquery"
          :show-total="total => `共${Total}条`"
        />
      </a-col>
    </a-row>
    <ADetail ref="aDetail" :recordId="appointId" />
    <ApmtRegistration
      :visible="registrationVisible"
      :patientId="PatientId"
      :ucPatientId="ucPatientId"
      :doctorId="DoctorId"
      :ucDoctorId="UcDoctorId"
      @setVisible="setVisible"
    />
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
      :scroll="{ y: 300 }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible.value = false"
        :active="summaryPannelActive"
      />
    </a-modal>
  </div>
</template>

<script setup>
import AFilter from './aFilter.vue'
import ADetail from '../../components/Appoint/index.vue'
import { ref, reactive, computed, watch, nextTick, defineProps, onMounted } from 'vue'
import { useStore } from 'vuex'
import { AppointColumns } from '@/constants/columns'
import { appointList, getDoctorHospitalSetting } from '@/api/workPlace/appoint'
import Config from '@/config/index'
import { handleTimeShowWeek } from '@/utils'
import ApmtRegistration from '@/components/ApmtRegistration/index.vue'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'

const props = defineProps({
  ucDoctorId: {
    type: Number,
    default: null
  },
  patientId: {
    type: Number,
    default: null
  },
  doctorId: {
    type: Number,
    default: null
  },
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  }
})
const paramQuery = reactive({
  reserveType: null
})
const currentQuery = params => {
  current.value = 1
  paramQuery.reserveState = params.status
  paramQuery.revisitType = params.revisitType
  listquery()
}
const store = useStore()
// const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const ucPatientId = computed(() => {
  return props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
})
const PatientId = computed(() => {
  return (
    props?.patientId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.businessId || ''
  )
})
const DoctorId = computed(() => {
  return (
    props?.doctorId || store?.state?.workOrder?.workOrderGroupInfo?.doctorInfo?.businessId || ''
  )
})
const UcDoctorId = computed(() => {
  return (
    props?.ucDoctorId || store?.state?.workOrder?.workOrderGroupInfo?.doctorInfo?.ucUserId || ''
  )
})
const registrationVisible = ref(false) // 预约挂号弹窗是否可见

// 预约挂号
const setVisible = () => {
  const status = !registrationVisible.value
  registrationVisible.value = status
  if (!status) {
    listquery()
  }
}

watch(ucPatientId, () => listquery())

const Total = ref(0)
const current = ref(1)
const pageSize = ref(10)
const TableData = ref([])

const listquery = async () => {
  const query = reactive({
    pageNo: current.value,
    pageSize: pageSize.value,
    ucPatientId: ucPatientId.value,
    reserveState: paramQuery.reserveState,
    revisitType: paramQuery.revisitType
  })
  const { list, totalCount } = await appointList(query)
  Total.value = totalCount
  TableData.value = list
  //  reserveType
}
const aDetail = ref(null)
const appointId = ref('')
const rowDetail = row => {
  appointId.value = row.id.toString()
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}

const sourceType = ref(0)
// 号源来源(0:施强健康,1:医院)
const isReserve = computed(() => sourceType.value === 1)
// 获取医生来源信息
function getSourceType() {
  const params = {
    ucDoctorId: UcDoctorId.value,
    doctorId: DoctorId.value
  }
  getDoctorHospitalSetting(params).then((result = {}) => {
    sourceType.value = result.sourceType
  })
}
const summaryPanelVisible = ref(false)
const summaryPannelActive = ref(0)
const chatSummaryId = ref('')
// 查看沟通小结详情
const summaryDetail = (record, active = 0) => {
  chatSummaryId.value = record.chatSummaryId
  summaryPanelVisible.value = true
  summaryPannelActive.value = active
}
onMounted(() => {
  getSourceType()
})
</script>

<style lang="scss" scoped>
.AContainer {
  padding: 10px 20px 0;
}
</style>
